import React from 'react';
import { useIntl } from 'react-intl';
import { ApiFilterOperation, Evidence } from '@eas/common-web';
import { EsFileState } from '@enums';
import { useColumns } from '../closed/spr-file-closed-columns';
import { useSprFiles } from '../spr-files';

export const SPR_FILES_REGISTRY_IDENTIFIER = 'SPR_FILES_REGISTRY';
export const SPR_FILES_REGISTRY_VERSION = 4;

export function SprFilesRegistry() {
  const intl = useIntl();

  const columns = useColumns();

  const { evidenceBag } = useSprFiles({
    evidenceProps: {
      identifier: SPR_FILES_REGISTRY_IDENTIFIER,
      version: SPR_FILES_REGISTRY_VERSION,
      tableProps: {
        columns,
        defaultPreFilters: [
          {
            field: 'state.id',
            operation: ApiFilterOperation.EQ,
            value: EsFileState.REGISTRY,
          },
        ],
        tableName: intl.formatMessage({
          id: 'ES__SPR_FILES_REGISTRY__TABLE__TITLE',
          defaultMessage: 'Spisy SPR - Spisovna',
        }),
      },
      detailProps: {
        toolbarProps: {
          showBtn: (btn) => !['NEW'].includes(btn),
          disableBtn: (btn) => !['REFRESH', 'SHARE'].includes(btn),
        },
      },
    },
  });

  return <Evidence {...evidenceBag} />;
}
